'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { SwitchRootContext } from './context/switch-root.context';
import { switchTrackRecipe } from './styles/switch-track.styles';
import type { SwitchTrackPropsInterface } from './types/switch-track.types';

/**
 * @since 10.0.0
 */

export const SwitchTrack = forwardRef<HTMLLabelElement, SwitchTrackPropsInterface>(
  (props: SwitchTrackPropsInterface, forwardedRef) => {
    const switchRootContext = useContext(SwitchRootContext);
    const {
      controlId = switchRootContext.controlId,
      disabled = switchRootContext.disabled,
      checkedState = switchRootContext.checkedState,
      size = switchRootContext.size,
      className,
      css: cssProp,
      ...rest
    } = props;

    const styles = css(switchTrackRecipe.raw({ disabled, checkedState, size }), cssProp);

    return (
      <label
        className={cx('c11n', styles, className)}
        data-c11n-component="Switch.Track"
        data-c11n-version={__C11N_VERSION__}
        htmlFor={controlId}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

SwitchTrack.displayName = 'Switch.Track';
